import { Col, Row } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import Can from '../../../security/Can';
import { ItemMenuCustom } from './styles';

const ItemMenu = props => {
  const {
    user,
    menu,
    onClickMenu,
    isTabletOrMobile,
    collapsed,
    ...defaultProperties
  } = props;

  return (
    <Can
      profile={user.profile}
      permissions={user.permissions}
      perform={menu.permissoes_que_habilitam_menu}
      data={menu.data}
      yes={() => (
        <ItemMenuCustom
          {...defaultProperties}
          key={menu.id}
          title={menu.name}
          onClick={() => onClickMenu(menu)}
          inlineIndent={menu?.parent_id > 0 ? 16 : 24}
        >
          <Row gutter={16}>
            {menu.icon && <Col span={3}>{menu.icon}</Col>}
            {((!isTabletOrMobile && !collapsed) || menu?.parent_id > 0) && (
              <Col
                className={menu.breakLine && 'lh-normal align-self-center'}
                span={menu?.parent_id > 0 ? 30 : 21}
              >
                <span>{menu.name}</span>
              </Col>
            )}
          </Row>
        </ItemMenuCustom>
      )}
    />
  );
};

ItemMenu.propTypes = {
  user: PropTypes.shape({
    profile: PropTypes.string,
    permissions: PropTypes.array,
  }).isRequired,
  menu: PropTypes.shape({
    id: PropTypes.number,
    icon: PropTypes.element,
    name: PropTypes.string,
    breakLine: PropTypes.bool,
    url: PropTypes.string,
    permissoes_que_habilitam_menu: PropTypes.any,
    data: PropTypes.any,
    menus: PropTypes.any,
  }).isRequired,
  onClickMenu: PropTypes.func.isRequired,
  isTabletOrMobile: PropTypes.bool.isRequired,
  collapsed: PropTypes.bool.isRequired,
};

export default ItemMenu;
